export default (cents: number = 0) => `$${Math.floor(cents / 100).toLocaleString()}`;
